<div class="header-container">
  <div class="logo-container">
    <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a>
    <!-- <a class="logo" href="#" (click)="navigateHome()">S-<span>buddy</span></a> -->
    <img class="logo title_logo" src="assets/images/SBHeader.png" alt="logo" />
  </div>
  <!-- <nb-select [selected]="currentTheme" (selectedChange)="changeTheme($event)" status="primary">
    <nb-option *ngFor="let theme of themes" [value]="theme.value"> {{ theme.name }}</nb-option>
  </nb-select> -->
</div>


<div class="header-container">
  <nb-actions size="small">
    <!-- <nb-action class="control-item" icon="email-outline"></nb-action> -->
    <nb-action class="control-item notification-action" (click)="toggleNotifications()" title="Notifications">
      <nb-icon icon="bell-outline"></nb-icon>
      <span *ngIf="notificationCount > 0" class="notification-badge">{{ notificationCount }}</span>
    </nb-action>
     <nb-action
      class="control-item"
      icon="question-mark-circle-outline"
      title="Help"
      (click)="openHelpLink()">
    </nb-action>
    <nb-action class="user-action" *nbIsGranted="['view', 'user']">
      <nb-user
        [onlyPicture]="userPictureOnly"
        [name]="user?.name"
        [picture]="user?.picture"
        [nbContextMenu]="userMenu"
        (nbContextMenuClick)="onMenuItemClick($event)">
      </nb-user>
    </nb-action>
    
    <nb-action class="control-item" icon="log-out-outline" (click)="logout()" title="Log out"></nb-action>
  </nb-actions>

  <!-- Notification Dropdown Panel -->
  <div class="chat-box notification-panel" *ngIf="isNotificationsOpen">
    <!-- Header -->
    <div class="notification-header">
      <div class="notif-header-top">
        <div class="notif-header-left">
          <div class="notif-bell-icon">
            <nb-icon icon="bell-outline"></nb-icon>
          </div>
          <div class="notif-title-group">
            <div class="notif-main-title">
              Notifications
              <span class="notif-unread-pill" *ngIf="notificationCount > 0">{{ notificationCount }} unread</span>
            </div>
            <div class="notif-subtitle">Recent activity and project updates</div>
          </div>
        </div>

        <div class="notif-header-actions">
          <button
            type="button"
            class="notif-action-btn"
            *ngIf="!isNotificationsLoading && notificationCount > 0"
            (click)="markAllAsRead()"
            title="Mark all notifications as read">
            <nb-icon icon="done-all-outline"></nb-icon>
            <span>Mark all read</span>
          </button>
          <button type="button" class="notif-close-btn" (click)="toggleNotifications()" aria-label="Close notifications">
            <nb-icon icon="close-outline"></nb-icon>
          </button>
        </div>
      </div>

      <!-- Filter Tabs -->
      <div class="notif-tab-bar">
        <button
          type="button"
          class="notif-tab-item"
          [class.active]="notificationTab === 'all'"
          (click)="setNotificationTab('all')">
          All
          <span class="tab-count-badge">{{ notifications.length }}</span>
        </button>
        <button
          type="button"
          class="notif-tab-item"
          [class.active]="notificationTab === 'unread'"
          (click)="setNotificationTab('unread')">
          Unread
          <span class="tab-count-badge unread" *ngIf="notificationCount > 0">{{ notificationCount }}</span>
        </button>
      </div>
    </div>

    <!-- Body -->
    <div class="chat-body notification-body">
      <!-- Loading State -->
      <div class="notif-status-card notif-loading" *ngIf="isNotificationsLoading">
        <div class="notif-spinner">
          <nb-icon icon="loader-outline"></nb-icon>
        </div>
        <div>
          <div class="status-heading">Loading notifications...</div>
          <div class="status-sub">Checking for your latest updates</div>
        </div>
      </div>

      <!-- Empty State -->
      <div class="notif-empty-state" *ngIf="!isNotificationsLoading && !filteredNotifications.length">
        <div class="empty-icon-circle">
          <nb-icon [icon]="notificationTab === 'unread' ? 'checkmark-circle-outline' : 'bell-off-outline'"></nb-icon>
        </div>
        <div class="empty-main-text">
          {{ notificationTab === 'unread' ? 'No unread notifications' : 'No notifications yet' }}
        </div>
        <div class="empty-sub-text">
          {{ notificationTab === 'unread' ? 'You are all caught up on all project updates!' : 'New project and approval updates will appear here.' }}
        </div>
      </div>

      <!-- Notification List -->
      <div class="notif-card-list" *ngIf="!isNotificationsLoading && filteredNotifications.length">
        <div
          class="notif-card"
          *ngFor="let notification of filteredNotifications; let i = index"
          [attr.data-index]="i"
          [ngClass]="{ 'is-read': isNotificationRead(notification), 'is-unread': !isNotificationRead(notification) }"
          (click)="markNotificationAsRead(notification)"
          [title]="isNotificationRead(notification) ? 'Marked as read' : 'Click to mark as read'">
          
          <div class="notif-avatar" [ngClass]="getNotificationIconClass(notification)">
            <nb-icon [icon]="getNotificationIcon(notification)"></nb-icon>
          </div>

          <div class="notif-details">
            <div class="notif-text">
              {{ getNotificationText(notification) }}
            </div>
            
            <div class="notif-meta">
              <span class="notif-timestamp">
                <nb-icon icon="clock-outline" class="meta-clock-icon"></nb-icon>
                {{ formatNotificationTime(getNotificationTime(notification)) }}
              </span>
              
              <span class="status-chip unread-chip" *ngIf="!isNotificationRead(notification)">
                <span class="pulse-dot"></span> New
              </span>
              <span class="status-chip read-chip" *ngIf="isNotificationRead(notification)">
                <nb-icon icon="checkmark-outline" class="check-small"></nb-icon> Read
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="notif-panel-footer">
      <span class="footer-count">
        {{ notificationCount }} unread of {{ notifications.length }} total
      </span>
      <button type="button" class="footer-refresh-btn" (click)="loadNotifications()" title="Refresh notifications">
        <nb-icon icon="refresh-outline" [class.spinning]="isNotificationsLoading"></nb-icon>
        <span>Refresh</span>
      </button>
    </div>
  </div>

</div>
